import React from 'react';
import { makeStyles } from '@material-ui/styles';
import hash from '../../helpers/hash';
import config from '../../helpers/config';

const useStyles = makeStyles(theme => ({
    
    logoSection: props => ({
        height: props.height || 300,
        position: 'relative',

        [theme.breakpoints.down("xs")]: {
            height: (props.height || 300) / 2,
        },

        '& > div.logoBg': {
            position: 'absolute',
            bottom: 0,
            top: 0,
            left: 0,
            right: "auto" ,
            backgroundImage: 'url(' + config.S3Endpoint + props.bannerBgImgUrl + ')',
            backgroundPosition: 'left',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            width: (props.height || 300) * (props.ratio || 1) + 'px', // ratio = bg W/H

            [theme.breakpoints.down("xs")]: {
                display: 'none',
            },

            '&.reverse': {
                right: 0,
                left: "auto" ,
                backgroundPosition: 'right',
                transform: 'rotate(180deg)'
            }


        }
    })
}));

export default (props) => {
    const classes = useStyles(props);
    return (
        <div className={classes.logoSection}>
            <div className="logoBg"></div>
            <div className="logoBg reverse"></div>
            { props.children }
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/client/components/LogoBanner.js